<template>
  <DefButtonSecondary class="go-sign-up" @click="goSingUp">
    {{ messages.btnCreateAccount }}
  </DefButtonSecondary>
</template>

<script>
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import { mapState } from 'vuex';
import useModal from '@use/useModal/useModal';
import SignUp from '@components/Cabinet/Entry/SignUp/SignUp.vue';

export default {
  name: 'GoSignUp',
  components: {
    DefButtonSecondary,
  },
  data() {
    return {
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ results }) => results?.messages?.entry,
    }),
  },
  methods: {
    goSingUp() {
      this.modal.show(
        SignUp,
        {},
        {
          width: '900px',
          backgroundClose: false,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.go-sign-up {
  width: 100%;
}
</style>
